export default "__VITE_ASSET__cO$wsBAD__"